var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.downloadURI(_vm.uri)}}},[_c('mdb-icon',{attrs:{"icon":"file-download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }